module.exports = __webpack_public_path__ + "odstraneni-tetovaze_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_4_before.jpg
// module id = 960
// module chunks = 0